<script>
import Vue from "vue";
import CountDown from "../CountDown.vue";
import ChallengeOfferLeft from "./ChallengeOfferLeft.vue";
import CheckoutForm from "../CheckoutForm.vue";
import Footer from "../../Footer.vue";

export default {
  name: "ChallengeOfferCheckout",
  page: {
    title: "SMART Blending Program",
    meta: [{ name: "description", content: "Joing the SMART Blending Program" }],
  },
  showCountDown: false,
  props: ["combos", "variant"],
  components: {
    ChallengeOfferLeft,
    CheckoutForm,
    Footer,
    CountDown,
  },
  data () {
    return {
      expirationDate: new Date("30 October 2020 23:59:59 PST"),
      changeBus: new Vue(),
      guaranteeImg: "redlock-ssl-30days.jpg",
      showCountDown: false,
    };
  },
  computed: {
    expirationDateComputed() {

      // if the parameters are not set, doesn't show the CountDown object
      if ( (!this.$route.query.d || this.$route.query.d === 'undefined') ||
           (!this.$route.query.dl || this.$route.query.dl === 'undefined') ) {
        return null;
      }

      // Check if 'd' query parameter exists and is a valid Unix timestamp
      const timestampParam = this.$route.query.d;
      const daysToAdd = parseInt(this.$route.query.dl) || 1;

      if (timestampParam) {
        try {
          // Convert the timestamp to milliseconds by multiplying by 1000
          const date = new Date(parseInt(timestampParam) * 1000);

          // Validate the date object
          if (isNaN(date.getTime())) {
            throw new Error('Invalid date');
          }

          // Use UTC methods to add days
          date.setUTCDate(date.getUTCDate() + daysToAdd);

          // Return the new timestamp in milliseconds
          const newTimestamp = date.getTime();
          console.log("New Timestamp: " + newTimestamp);

          return newTimestamp;
        } catch (e) {
          console.error('Error parsing timestamp:', e);
        }
      }

      // If no valid 'd' query parameter or error in parsing, return current time + 7 days in timestamp
      console.error('Invalid or no timestamp parameter provided in the URL, using default.');
      const defaultDate = new Date();
      defaultDate.setUTCDate(defaultDate.getUTCDate() + 7);
      return defaultDate.getTime();
    }
  },
  methods: {
    addHours(hours) {
      const today = new Date();
      today.setHours(today.getHours() + hours);
      return today;
    },
  },
}

</script>

<template>
  <b-container style="background-color: white; padding: 0 3rem">        
    <CountDown :expirationDate="expirationDateComputed"/>
    <b-row class="checkout-content">
      <b-col sm="12" lg="6" class="content" style="text-align: left; color: #293847">
        <ChallengeOfferLeft />
      </b-col>
      <b-col sm="12" lg="6" class="checkout">
        <CheckoutForm :loadCombos="[2]" 
                      :guaranteeImg="guaranteeImg" 
                      :changeBus="this"
                      :expirationDate="expirationDateComputed"
        />
      </b-col>
    </b-row>
    <Footer />
  </b-container>
</template>

<style lang="scss">
$vs-state-active-bg: #f7f7f7;
$vs-state-active-color: #444;

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Light.ttf);
  font-weight: 200;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Regular.ttf);
  font-weight: 400;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Bold.ttf);
  font-weight: 600;
}

// Global Settings
$font-family: "OpenSans";
$font-bold: 700;

// Form Settings
$border-input: 1px solid #f7f7f7;
$bg-input: #f7f7f7;
$color-input: #000000;
$font-size-input: 18px;
$color: #000000;
$line-height-input: 23px;
$padding-input: 15px 18px 15px 55px;
$link-color: #68a432;

// Icon Settings
$icon-color: #999999;

* {
  font-family: $font-family;
}

.alert-error {
  color: #ff0000;
  font-size: 16px;
  margin: 0 !important;
  padding: 0 !important;
  text-align: center;
}

@media screen and (min-width: 481px) {
  /*.header-checkout:before {
    content: url(../../../assets/images/img-icons.png);
    position: absolute;
    right: 0;
    pointer-events: none;
  }*/
}
.checkout-content {
  padding-bottom: 0;
  margin-bottom: 0;
  display: flex;
  align-items: stretch;
}

.logo-row {
  margin: 65px 0 65px 0;
  .logoCheckout {
    width: 100%;
    max-width: 228px !important;
    margin: 0 auto;
  }
}

#bonus-left {
  font-size: 1.05rem;
  line-height: 2.75em;
}

ul#bonus-left > li {
  font-weight: bold;
  list-style: disc;
}
ul#bonus-left > li li {
  font-weight: normal;
  list-style: disc;
}

ul#bonus-right {
  line-height: 2.75em;
  width: 88%;
}

ul#bonus-right > li {
  font-weight: bold;
  list-style: disc;
}

ul#bonus-right > li li {
  font-weight: normal;
  line-height: 1em;
  margin-bottom: 2rem;
  list-style: disc;
}

ul#bonus-right h4 {
  font-size: 1.1rem;
  margin-bottom: 6px;
  margin-top: 16px;
}
#expired-offer-link {
  font-size: 1.5rem;
  color: red;
  font-weight: 900;
}

#expired-offer-link:hover {
  color: red;
  text-decoration: underline;
}
#expired-offer-link:visited {
  color: red;
  text-decoration: none;
}
.header-checkout {
  text-align: center;
  h2 {
    font-size: 36px !important;
    font-weight: 600;
    color: black ;
  }
}

#time-counter-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 40px 0;
}

#time-counter-container div {
  width: 3em;
  font-size: 3rem;
  font-weight: 400;
}
#time-counter-container span {
  float: right;
}
#time-counter-container .value {
  height: 60px;
}
#time-counter-container .label {
  font-weight: normal;
  font-size: 0.9rem;
  width: auto;
  text-align: center;
  text-transform: uppercase;
  color: #555;
}
</style>
